<template>
  <div id="text-topics">
    <div class="topic_title">{{bankData.order}}.( {{typeText}} ){{bankData.questionTitle}}</div>
    <div class="topic_box">
      <el-input
        :rows="5"
        disabled
        placeholder="请输入内容"
        type="textarea"
        v-model="bankData.user_select"
      ></el-input>
    </div>

    <div class="el-Parsing">
      <div class="title">
        <div class="title_item">
          <span class="title-span">参考答案：</span>
          <span class="blue">{{bankData.questionAnswer}}</span>
        </div>
        <div class="title_item">
          你的答案：
          <span class="red">{{bankData.select}}</span>
        </div>
        <div class="title_cursor">
          <el-popover placement="bottom-start" trigger="click" v-model="visible" width="400">
            <div class="text_box">
              <div class="header">
                <el-checkbox-group size="small" v-model="check_li">
                  <el-checkbox-button :key="item" :label="item" v-for="item in lists">{{item}}</el-checkbox-button>
                </el-checkbox-group>
              </div>
              <div class="body">
                <el-input :rows="2" placeholder="请输入内容" type="textarea" v-model="textarea"></el-input>
              </div>
              <div class="submit">
                <div @click="submit_feed" class="btn">提交</div>
              </div>
            </div>
            <!-- <div :style="{'disabled': disabled}" class="warnin" slot="reference">
              <img alt src="@/assets/img/Exam/报错.png" srcset />
              <span>试题报错</span>
            </div>-->
          </el-popover>
          <!-- <div class="keep" v-if="!bankData.iscollect">
            <img @click="collects" alt src="@/assets/img/Exam/收藏.png" srcset />
            <span class="no_keep">试题收藏</span>
          </div>-->
          <!-- <div class="keep" v-else>
            <img @click="collects" alt src="@/assets/img/Exam/已收藏.png" srcset />
            <span class="is_keep">已收藏</span>
          </div>-->
        </div>
      </div>
      <div class="content" v-if="bankData.questionDescribe">答案解析：{{bankData.questionDescribe}}</div>
      <div class="content" v-else>答案解析：解析正在更新中...</div>
      <div class="btn_keep"></div>
    </div>
  </div>
</template>
<script>
// import { methods } from '../../h5/questionBank/AnswerSheet.vue'
// import * as Ajax from '@/assets/api/question/question'
export default {
  name: 'textTopics',
  props: ['bankData', 'typeText'],
  data () {
    return {
      content: '',
      visible: false,
      disabled: false,
      lists: ['题干', '选项', '答案', '解析'],
      textarea: '',
      check_li: ['题干']
    }
  }
  // methods: {
  //   submit_feed() {
  //     let data = {
  //       q_id: this.bankData.q_id,
  //       content: this.check_li.toString() + ':' + this.textarea
  //     }
  //     Ajax.setFeed(data)
  //       .then(res => {
  //         if (res && Number(res.status_code) === 200) {
  //           this.$message.success(res.message)
  //           this.visible = false
  //           this.disabled = true
  //         } else {
  //           this.$message.warning(res.message)
  //         }
  //       })
  //       .catch(err => {
  //         console.log(err)
  //       })
  //   },
  //   setCollect() {
  //     let my_answer =
  //       this.bankData.user_select.indexOf('[') > -1
  //         ? ''
  //         : this.bankData.user_select
  //     let data = {
  //       q_id: this.bankData.q_id,
  //       exam_id: this.bankData.exam_id,
  //       q_type: this.bankData.question_type,
  //       my_answer: my_answer,
  //       type: this.bankData.parent_id
  //     }
  //     Ajax.setCollect(data)
  //       .then(res => {
  //         if (res && Number(res.status_code) === 200) {
  //           this.$message.success(res.message)
  //           let obj = {
  //             q_id: this.bankData.q_id,
  //             collect: true
  //           }
  //           this.$emit('setCollect', obj)
  //         } else {
  //           this.$message.warning(res.message)
  //         }
  //       })
  //       .catch(err => {
  //         console.log(err)
  //       })
  //   },
  //   delCollect() {
  //     let data = {
  //       q_id: this.bankData.q_id,
  //       exam_id: this.bankData.exam_id
  //     }
  //     Ajax.delCollect(data)
  //       .then(res => {
  //         if (res && Number(res.status_code) === 200) {
  //           this.$message.success(res.message)
  //           let obj = {
  //             q_id: this.bankData.q_id,
  //             collect: false
  //           }
  //           this.$emit('setCollect', obj)
  //         } else {
  //           this.$message.warning(res.message)
  //         }
  //       })
  //       .catch(err => {
  //         console.log(err)
  //       })
  //   },
  //   collects() {
  //     if (this.bankData.collect) {
  //       this.delCollect()
  //     } else {
  //       this.setCollect()
  //     }
  //   }
  // }
}
</script>
 <style lang="less" scoped>
.btn {
  cursor: pointer;
}
.eye_btn {
  margin: 10px;
}
.option {
  line-height: 40px;
}
.warnin img,
.warnin span {
  vertical-align: middle;
}
.warnin {
  width: 78px;
  height: 28px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(242, 242, 242, 1);
  border-radius: 4px 0px 0px 4px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  text-align: center;
  margin-right: 10px;
}
.keep {
  width: 78px;
  height: 28px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(242, 242, 242, 1);
  border-radius: 4px 0px 0px 4px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  text-align: center;
  margin-right: 10px;
}
.keep img {
  vertical-align: middle;
}

.title {
  margin: 20px 0;
}
.title_cursor {
  display: flex;
}
.title-span {
  width: 112%;
}
.title_item {
  margin-right: 25px;
  width: 60%;
  height: 20%;
  align-items: normal;
}
.headtit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}
.el-Parsing {
  border-top: 1px solid rgba(242, 242, 242, 1);
  border-bottom: 1px solid rgba(242, 242, 242, 1);
  margin: 35px 0;
}
.content {
  margin-bottom: 20px;
}
.topic_title {
  line-height: 60px;
}
.boxcheck {
  display: inline-block;
  text-align: center;
  width: 25px;
  height: 25px;
  background: rgba(254, 254, 254, 1);
  border: 1px solid rgba(136, 136, 136, 1);
  border-radius: 50%;
  line-height: 22px;
}
.tive {
  background: rgba(255, 39, 64, 1);
  color: white;
  border: 1px solid rgba(255, 39, 64, 1);
}
.tives {
  background: rgba(71, 162, 255, 1);
  color: #ffffffff;
  border: 1px solid rgba(71, 162, 255, 1);
}
</style>